export default __webpack_public_path__ + "static/extrabold-016c7a144140d41853f9c07986b4ea6c.woff2";